import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class ManageAuctionFeesService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getAuctionFeesData(searchParams): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.search;
    let params = new HttpParams();

    params = params.set('clientId', searchParams.Client)
      .set('loanType', searchParams.LoanType)
      .set('typeOfSale', searchParams.TypeOfSale)
      .set('feeType', searchParams.FeeType)
      .set('feeAmount', searchParams.FeeAmount)
      .delete('clientId', '')
      .delete('loanType', '')
      .delete('typeOfSale', '')
      .delete('feeType', '')
      .delete('feeAmount', '');
    console.log(params);
    return this._http.get<any>(`${api}`, { params });
  }

  save(params): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.create;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, params, this.httpOptions);
  }

  getSelectorsData(): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.changeLogSelectors;
    return this._http.get<any>(`${api}`);
  }

  getUniqueClientID(): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.uniqueClientId;
    return this._http.get<any>(`${api}`);
  }

  update(params):  Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.update;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, params, this.httpOptions);
  }

  delete(matrixIds): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.delete;
    let params = new HttpParams();
    params = params.set('AuctionFeesMatrixId', matrixIds);
    return this._http.get<any>(`${api}`, { params });
  }

  getChangeLogSelectorsData(): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.changeLogSelectors;
    return this._http.get<any>(`${api}`);
  }

  getChangeLogData(changeLogParams): Observable<any> {
    const api = (<any>_GlobalNS).api.auctionFees.changeLog;
    let params = new HttpParams();
    params = params.set('ClientId', changeLogParams.UniqueClientID)
                    .set('ChangedBy', changeLogParams.ChangedBy)
                    .set('FeeType', changeLogParams.FeeType)
                    .set('FeeAmount', changeLogParams.FeeAmount)
                    .set('TypeOfSale', changeLogParams.TypeOfSale)
                    .set('LoanType', changeLogParams.LoanType)
                    .set('FromDate', changeLogParams.FromDate)
                    .set('ToDate', changeLogParams.ToDate)
                    .delete('ChangedBy', '')
                    .delete('ClientId', '')
                    .delete('FromDate', '')
                    .delete('ToDate', '')
                    .delete('FeeType','')
                    .delete('FeeAmount','')
                    .delete('TypeOfSale','')
                    .delete('LoanType','')

    return this._http.get<any>(`${api}`,{params});
  }

}